import { ServerGroupManagerDetails } from './ServerGroupManagerDetails';
import type { ApplicationStateProvider } from '../application';
import { registerApplicationState } from '../application';
import type { INestedState } from '../navigation';

export interface IServerGroupManagerStateParams {
  provider: string;
  accountId: string;
  region: string;
  name: string;
}

const serverGroupManagerDetails: INestedState = {
  name: 'serverGroupManager',
  url: '/serverGroupManagerDetails/:provider/:accountId/:region/:name',
  views: {
    'detail@../insight': {
      component: ServerGroupManagerDetails,
      $type: 'react',
    },
  },
  resolve: {
    accountId: ['$stateParams', ($stateParams: IServerGroupManagerStateParams) => $stateParams.accountId],
    serverGroupManager: ['$stateParams', ($stateParams: IServerGroupManagerStateParams) => $stateParams],
  },
  data: {
    pageTitleDetails: {
      title: 'Server Group Manager Details',
      nameParam: 'name',
      accountParam: 'accountId',
      regionParam: 'region',
    },
    history: {
      type: 'serverGroupManagers',
    },
  },
};

function addServerGroupManagerDetailsState(applicationStateProvider: ApplicationStateProvider): void {
  applicationStateProvider.addInsightDetailState(serverGroupManagerDetails);
}

registerApplicationState((applicationStateProvider: ApplicationStateProvider) => {
  addServerGroupManagerDetailsState(applicationStateProvider);
});
